import { CheckIcon, X } from 'lucide-react';

type Props = {
    isPositive: boolean;
    positiveText: string;
    negativeText: string;
};

export function ProfileDetailsFlag({ isPositive, positiveText, negativeText }: Props) {
    const Icon = isPositive ? CheckIcon : X;

    return (
        <div className="flex items-center gap-1">
            <Icon
                aria-hidden="true"
                strokeWidth={1}
                className={isPositive ? 'size-6 text-toast-success' : 'size-6 text-destructive'}
            />
            <p className="text-base font-bold text-foreground">
                {isPositive ? positiveText : negativeText}
            </p>
        </div>
    );
}
